import { useModel } from "cosmonaut";
import { InstrumentId } from "../market/asset-id";
import { QuoteModel } from "../model/quote-model";

export function useQuotes(instrumentIds: InstrumentId[]) {
  return useModel(
    Object.fromEntries(instrumentIds.map((id) => [id.key, QuoteModel({ id })]))
  );
}
